import { render, staticRenderFns } from "./VPolygon.vue?vue&type=template&id=74857bcc&scoped=true&lang=pug&"
import script from "./VPolygon.vue?vue&type=script&lang=js&"
export * from "./VPolygon.vue?vue&type=script&lang=js&"
import style0 from "./VPolygon.vue?vue&type=style&index=0&id=74857bcc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74857bcc",
  null
  
)

export default component.exports